import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

export interface ConfirmationData {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ConfirmationService {
  private confirmationSubject = new Subject<ConfirmationData & { resolve: (result: boolean) => void }>();

  confirmation$ = this.confirmationSubject.asObservable();

  confirm(data: ConfirmationData): Promise<boolean> {
    return new Promise((resolve) => {
      this.confirmationSubject.next({
        ...data,
        confirmText: data.confirmText || 'Confirmer',
        cancelText: data.cancelText || 'Annuler',
        resolve
      });
    });
  }
}
